module.exports = __webpack_public_path__ + "949d019319b9309c086392ac1270ac6b.pdf";